module.exports = __webpack_public_path__ + "static/media/team-auth.e401db9c.png";